import { useEffect } from "react";
import { ManualInput } from "../../../../utils/form";

const MedicineManualInput = (props) => {
  const { form, name, setSelectedTemplate } = props;
  const { setValue, watch } = form;

  const currentTextValue = watch(`${name}.text`);

  useEffect(() => {
    setValue(`${name}.text`, currentTextValue);
  }, [currentTextValue, setValue, name]);

  return (
    <ManualInput
      label={
        props.templateType === "order"
          ? "Solicitud de prácticas"
          : "Prescripción"
      }
      {...props}
      name={`${props.name}.text`}
    />
  );
};

export default MedicineManualInput;
